import { signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';
import { withReset } from '@angular-architects/ngrx-toolkit';
import { MemoryCacheItem, MemoryCacheService } from '../cache/memory-cache.service';
import { withWebStorageSync } from './web-storage-sync.feature';

export const withStorageServiceFeature = (storageKey: string, showPortalCustomerType = false, prefix = 'mwe') => {
  if ((!storageKey && typeof storageKey !== 'string') || !storageKey?.length)
    throw new Error('storageServiceFeature requires a storageKey to be set as string');

  return signalStoreFeature(
    withState({
      _storageService: true,
    }),
    withReset(),
    withWebStorageSync({
      storage: typeof sessionStorage !== 'undefined' ? sessionStorage : undefined,
      prefix: prefix,
      storageKey: storageKey,
      showPortalCustomerType: showPortalCustomerType,
      excludeKeys: [
        'isLoggedIn',
        'hasAccount',
        'isImpersonating',
        'isPartner',
        'portalCustomerType',
        'autoRegistrationSuccessful',
        'isNewAccountCreated',
        'deleteProfileSuccess',
      ],
    }),
    withMethods(store => {
      const clear = () => {
        store.resetState();
        store.clearStorage();

        // Extends the withConfirmationStatusState Feature for clearing the MemoryCacheService
        const s = store as unknown as {
          _memoryCacheService?: MemoryCacheService;
          _memoryCacheItem?: () => MemoryCacheItem | null;
        };

        if (!s?._memoryCacheService || !s?._memoryCacheItem) return;

        const item = s._memoryCacheItem();
        if (!item) return;

        s._memoryCacheService.clear(item);
      };

      return {
        clear,
      };
    }),
    withHooks(store => ({
      onDestroy() {
        store.clear();
      },
    })),
  );
};
